import styled from "styled-components"

export const StoryTimelineWrapper = styled.section`
`
